module.exports = __webpack_public_path__ + "officialStatic/img/wx-spec-zhuanye.296db01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/wx-spec-zhuanye.png
// module id = 04EG
// module chunks = 0